import { render, staticRenderFns } from "./KPModal.vue?vue&type=template&id=19ad60f6&"
import script from "./KPModal.vue?vue&type=script&lang=js&"
export * from "./KPModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports